import BaseComponent from "../../BaseComponent";

const CURRENCY_POINTS = 'points';

export default class RewardsExchangeRate extends BaseComponent {
    public init(): void {
        const $scope = this.$component.closest('#payoff-settings');
        const $payoffAmount = $scope.find('input[name="rewards[payoff_amount]"]');
        const $currency = $scope.find('select[name="rewards[currency]"]');
        const $exchangeValue = $scope.find('input[name="rewards[exchange_value]"]');

        const update = () => this.updateText($payoffAmount, $currency, $exchangeValue);

        $payoffAmount.on('input change', update);
        $currency.on('change', update);
        $exchangeValue.on('input change', update);

        update();
    }

    private updateText(
        $payoffAmount: JQuery<HTMLElement>,
        $currency: JQuery<HTMLElement>,
        $exchangeValue: JQuery<HTMLElement>,
    ): void {
        const currency = String($currency.val());
        const payoffAmount = String($payoffAmount.val() ?? '').trim();
        const exchangeValue = String($exchangeValue.val() ?? '').trim();

        if (currency === CURRENCY_POINTS || payoffAmount === '' || exchangeValue === '') {
            this.$component.html('');
            return;
        }

        const text = this.translator.translate('payoff_exchange_rate_hint')
            .replace('%payoff_amount%', payoffAmount)
            .replace('%currency%', currency)
            .replace('%exchange_value%', exchangeValue);

        this.$component.html(text);
    }
}
